export default "__VITE_ASSET__C6UDC_w$__"